import { useReadMemory } from "./useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { useState } from "react";

export const useGetRole = () => {
    const user = useReadMemory(MemoryType.USER);
    const [role] = useState(() => user?.jobTitle);
    const roleValue = role?.replace("Demo ", "");
    return roleValue;
};
